import React, { useEffect, useState } from 'react'
import {
    Form,
    Select,
    Typography,
    Row,
    Col,
    Button,
    Input,
    Table,
    Tabs,
    message,
    Divider,
    Progress
} from "antd";
import './index.less'
const { Item } = Form;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
import { platformApi } from '../../../../../../../api'

const JobComplaint = ({
    data,
    totalComplaints,
    setTotalComplaints,
    status
}) => {
    const [dataSource, setDataSource] = useState([])
    const [complaintList, setComplaintList] = useState([])
    const [complaint, setComplaint] = useState("")
    const [completionPercentage, setCompletionPercentage] = useState(0)

    // Function to refresh complaints data from server
    const refreshComplaints = async () => {
        if (data && data.id) {
            try {
                console.log("Refreshing complaints data for job order:", data.id);
                const response = await platformApi.get(`/api/jobOrder/${data.id}`);
                if (response.status === 200 && response.data) {
                    const updatedData = response.data.response?.data || response.data;
                    console.log("Refreshed data:", updatedData);
                    setDataSource(updatedData.complaint || []);
                    setTotalComplaints(updatedData.complaint || []);
                    calculateCompletionPercentage(updatedData.complaint || []);
                }
            } catch (err) {
                console.error("Error refreshing complaints:", err);
            }
        }
    }

    useEffect(() => {
        if (data && data.id) {
            // Only update data source if it's the first load or if the job has changed entirely
            // This prevents stagnant 'data' props from overwriting our fresh local state
            setDataSource(data.complaint || [])
            calculateCompletionPercentage(data.complaint || [])
        }
    }, [data && data.id])

    // Add effect to refresh data when component becomes visible
    useEffect(() => {
        refreshComplaints();
    }, [status]); // Refresh when tab changes

    useEffect(() => {
        if (dataSource) {
            setTotalComplaints(dataSource)
            calculateCompletionPercentage(dataSource)
        }
    }, [dataSource])

    const calculateCompletionPercentage = (complaints) => {
        if (!complaints || complaints.length === 0) {
            setCompletionPercentage(0)
            return
        }
        const completed = complaints.filter(c => c.jobStatus === 'COMPLETED').length
        const percentage = (completed / complaints.length) * 80 // 80% max as per requirement
        setCompletionPercentage(Math.round(percentage))
    }

    const columns = [
        {
            title: "S.No",
            render: (d) => (
                <h3>{totalComplaints.indexOf(d) + 1}</h3>
            )
        },
        {
            title: "Complaints",
            render: (data) => (<div>
                <p>{data.complaint}</p>
                <p style={{ color: data.jobStatus === 'COMPLETED' ? 'green' : 'orange' }}>
                    Status: {data.jobStatus === 'COMPLETED' ? 'Completed' : 'Pending'}
                </p>
            </div>)
        }
    ]

    const handleComplaint = (e) => {
        let v = e.target.value
        // Remove special characters, allow alphanumeric, spaces, and basic punctuation
        const cleanValue = v.replace(/[^a-zA-Z0-9\s.,!?-]/g, '');
        setComplaint(cleanValue)
    }

    const addComplaint = async () => {
        if (!complaint.trim()) {
            message.warning("Please enter a complaint")
            return
        }

        const newComplaint = {
            complaint: complaint,
            jobStatus: 'VEHICLERECEIVED'
        }

        const updatedComplaints = [...dataSource, newComplaint]
        setDataSource(updatedComplaints)
        setTotalComplaints(updatedComplaints)
        setComplaint("")

        try {
            console.log("Adding complaint with data:", {
                id: data.id,
                complaint: updatedComplaints
            });

            // Send minimalist payload to avoid partial update issues on backend
            const response = await platformApi.put(`/api/jobOrder/${data.id}`, {
                id: data.id,
                complaint: updatedComplaints
            })

            console.log("API Response:", response);

            // Check for application-level success code
            if (response.status === 200 && response.data.code === 200) {
                message.success("Job Order Updated successfully", 2)
                // Refresh data from server to ensure consistency
                await refreshComplaints();
            } else {
                console.error("API Error Response:", response);
                const errorMsg = response.data.message || response.data.msg || "An error occurred";
                message.error(`Unable to update Job Order: ${errorMsg}`, 2)
                // Revert local state to match server if update failed
                await refreshComplaints();
            }
        } catch (err) {
            console.error("Error on Job Order : ", err)
            message.error(`Unable to update Job Order: ${err.message || 'Network error'}`, 2)
            // Revert local state to match server if network failed
            await refreshComplaints();
        }
    }

    return (
        <>
            <div className="Complaints">
                <div style={{ marginBottom: '2rem' }}>
                    <h3>Work Completion Status</h3>
                    <Progress
                        percent={completionPercentage}
                        status={completionPercentage === 80 ? "success" : "active"}
                        format={percent => `${percent}%`}
                    />
                    <Text type="secondary">Note: Maximum completion is 80% as 20% is reserved for washing and final inspection</Text>
                </div>

                <Divider />

                <div style={{ display: 'inline' }}>
                    <h3>Job Details:</h3>
                </div>
                <div id="complaints">
                    <Table
                        pagination={false}
                        columns={columns}
                        dataSource={totalComplaints}
                    />
                </div>
                {/* Complaint input box hidden
                    (status === 0 || status === 1) && dataSource.some(c => c.jobStatus !== 'COMPLETED') && new URLSearchParams(window.location.search).get('edit') === 'true' ?
                        <span>
                            <Divider />
                            <div>
                                <Row>
                                    <Col xs={24} md={20}>
                                        <TextArea
                                            id="cp"
                                            onChange={(e) => handleComplaint(e)}
                                            value={complaint}
                                            placeholder="Enter Complaint"
                                            rows={3}
                                        />
                                    </Col>
                                    <Col xs={24} md={4} style={{ display: 'flex', justifyContent: 'space-around', marginTop: '1rem' }}>
                                        <Button type="primary" onClick={addComplaint}>Add</Button>
                                    </Col>
                                </Row>
                            </div>
                        </span>
                        : null
                */}
            </div>
        </>
    )
}

export default JobComplaint;